var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/48/Arch_Amazon-Simple-Storage-Service_48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CAE3E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/48/Arch_Amazon-Simple-Storage-Service_48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/48/Amazon-Simple-Storage-Service_48",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7588,25.9482 L39.9928,24.1312 C42.1658,25.3852 42.8418,26.1212 43.0368,26.4242 C42.7128,26.4852 41.8318,26.5092 39.7588,25.9482 L39.7588,25.9482 Z M22.4998,13.0002 C12.1248,13.0002 5.3818,10.4882 4.9998,8.6962 L4.9998,8.5112 C5.3488,7.3922 11.1398,4.0002 22.4998,4.0002 C33.8398,4.0002 39.6318,7.3812 39.9998,8.5052 L39.9998,8.6162 C39.7238,10.4462 32.9608,13.0002 22.4998,13.0002 L22.4998,13.0002 Z M37.8178,25.3622 C33.0528,23.7972 26.9118,20.9792 24.5938,19.8882 C24.5348,18.7862 23.6278,17.9062 22.5118,17.9062 C21.3578,17.9062 20.4178,18.8452 20.4178,20.0002 C20.4178,21.1542 21.3578,22.0942 22.5118,22.0942 C22.9688,22.0942 23.3888,21.9422 23.7328,21.6932 C26.1318,22.8222 32.6188,25.7982 37.5578,27.3802 L35.8368,40.7242 C35.5828,42.3522 30.9188,44.0002 22.4968,44.0002 C14.0718,44.0002 9.4048,42.3522 9.1548,40.7512 L5.4348,11.8142 C8.9448,13.9152 15.7488,15.0002 22.4998,15.0002 C29.2498,15.0002 36.0538,13.9152 39.5648,11.8152 L37.8178,25.3622 Z M41.9998,8.5002 C41.9998,5.4312 33.6608,2.0002 22.4998,2.0002 C11.3388,2.0002 2.9998,5.4312 2.9998,8.5002 L2.9998,9.0432 L7.1738,41.0332 C7.8748,45.5162 18.1228,46.0002 22.4968,46.0002 C26.8688,46.0002 37.1128,45.5162 37.8178,41.0072 L39.5008,27.9472 C40.7778,28.2792 41.8118,28.4562 42.6158,28.4552 C43.6058,28.4552 44.2728,28.2032 44.6968,27.6972 C45.0468,27.2812 45.1848,26.7562 45.0848,26.2212 C44.8568,25.0002 43.4028,23.7122 40.3698,22.0442 L40.2698,21.9892 L41.9998,9.0442 L41.9998,8.5002 Z",
    id: "Amazon-Simple-Storage-Service-Icon_48_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonS3);
export default __webpack_public_path__ + "static/media/amazon_s3.4c12b77f2ed5eba3d1753f7bceffa085.svg";
export { ForwardRef as ReactComponent };